import { Component, OnInit, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title } from '@angular/platform-browser';

import { FuncionService } from '../../servicios/funcion.service';
import { Base64, Metatags, User } from '../../utilidades/utilidades';

import { Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { environment } from '../../../environments/environment.prod';

import * as $ from 'jquery';

@Component({
  	selector: 'app-home',
  	templateUrl: './home.component.html',
  	styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

	showCategorias:boolean = true;
	newUser:User;

	listaCarouselImages:any = {
		movile:[
			{
				img:"assets/images/carousel/1m.webp",
				titulo:"Feliz día del padre, 20% de descuento en sudaderas.",
				link:{
					path: "/tienda",
					params: [{
						categorias: "Mw==-alimento" 
					}]
				}
			}, {
				img:"assets/images/carousel/2m.webp",
				titulo:"Envios gratuitos en la CDMX y zona metropolitana.",
				link:{
					path:"/tienda",
					params: [
						{ categorias: "Mg==-perros" },
						{ categorias: "MTQ=-jueguetes"},
						{ categorias: "OTM=-premios"}
					]
				}
			},
			{img:"assets/images/carousel/3m.webp",
				titulo:"Todos los jueves de este mes de mayo 15% en ropa para tu compañero",
				link:{
					path:"/tienda",
					params:[{
						buscar: "sudaderas"
					}]
				}
			},  
			{img:"assets/images/carousel/4m.webp",
				titulo:"Mejores marcas de alimentos premium, para tu mejor amigo de acuerdo a sus necesidades.",
				link:{
					path:"/tienda",
					params: [{
						buscar: "vestidos"
					}]
				}
			},{
				img:"assets/images/carousel/5m.webp",
				titulo:"Reserva tu cita con nosotros.",
				link:{
					path:this.newFuncionService.currentUserValue.session?"/mi-cuenta":"/acceso"
				}
			}
		],
		desktop:[
			{
				img:"assets/images/carousel/1.webp",
				titulo:"Feliz día del padre, 20% de descuento en sudaderas.",
				link:{
					path: "/tienda",
						params: [{
							categorias: "Mw==-alimento" 
						}]				
					}
			}, {
				img:"assets/images/carousel/2.webp",
				titulo:"Envios gratuitos en la CDMX y zona metropolitana.",
				link:{
					path:"/tienda",
					params: [
						{ categorias: "Mg==-perros" },
						{ categorias: "MTQ=-jueguetes"},
						{ categorias: "OTM=-premios"}
					]
				}
			}, 
			{
				img:"assets/images/carousel/3.webp",
				titulo:"Todos los jueves de este mes de mayo 15% en ropa para tu compañero",
					link:{
					path:"/tienda",
						params: [{ 
							buscar: "sudaderas" 
					}]
				}
			}, 
			{
				img:"assets/images/carousel/4.webp",
				titulo:"Mejores marcas de alimentos premium, para tu mejor amigo de acuerdo a sus necesidades.",
				link:{
					path:"/tienda",
					params: [{
						buscar: "vestidos"
					}]
				
				}
			},{
				img:"assets/images/carousel/5.webp",
				titulo:"Reserva tu cita con nosotros.",
				link:{
					path:this.newFuncionService.currentUserValue.session?"/mi-cuenta":"/acceso"
				}
			}
		]
	};
	listaCarousel:any[] = [];
	altoCarousel:number = 440;
	anchoCarousel:number = 0;
	numberOfShowMarcas:number = 4;

	anchoCarouselTarjetas:number = 0;

	numberOfShowSubcategorias:number = 6;

	listaMarcas:any[] = [{
		nombre:"Royal canin",
		alias:"royal-canin",
		id:5,
		img:"assets/images/proveedores/royalcanin.png"
	},{
		nombre:"Pro plan",
		alias:"pro-plan",
		id:6,
		img:"assets/images/proveedores/proplan.png"
	},{
		nombre:"Nupec",
		alias:"nupec",
		id:7,
		img:"assets/images/proveedores/nupec.png"
	},{
		nombre:"Hill´s",
		alias:"hills",
		id:8,
		img:"assets/images/proveedores/hills.png"
	},{
		nombre:"Animal planet",
		alias:"animal-planet",
		id:3,
		img:"assets/images/proveedores/animalplanet.png"
	},{
		nombre:"Perfect sense",
		alias:"perfect-sense",
		id:4,
		img:"assets/images/proveedores/perfect.png"
	},{
		nombre:"Eukanuba",
		alias:"eukanuba",
		id:9,
		img:"assets/images/proveedores/eukanuba.png"
	},{
		nombre:"Diamond",
		alias:"diamond",
		id:10,
		img:"assets/images/proveedores/diamon.png"
	},{
		nombre:"Instinct",
		alias:"instinct",
		id:11,
		img:"assets/images/proveedores/instinct.jpeg"
	},{
		nombre:"Purina excellent",
		alias:"purina-excellent",
		id:13,
		img:"assets/images/proveedores/excellent.png"
	},{
		nombre:"Optimo",
		alias:"optimo",
		id:12,
		img:"assets/images/proveedores/optimo.jpeg"
	}];

	listaCategorias:any[] = [];
	listaSubcategorias:any[] = [];


	banners1:any[] = [{
		img:"assets/images/banners/devolucion.png",
		nombre:"Devoluciones sin costo y ebtrega el mismo día.",
		link:"tienda"
	}];

	banners2:any[] = [{
		img:"assets/images/banners/servicios.webp",
		nombre:"Servicios de estética y consultas.",
		link:"ubicaciones"
	},{
		img:"assets/images/banners/envio.webp",
		nombre:"Productos con envío gratis.",
		link:"tienda"
	}];

	banners3:any[] = [{
		img:"assets/images/banners/estetica.jpg",
		nombre:"Servicios de estética.",
		link:"ubicaciones"
	},{
		img:"assets/images/banners/veterinaria.jpg",
		nombre:"Servicios de veterinaría.",
		link:"ubicaciones"
	}];

	listaProductosMarca:any[] = [];
	listaProductosAlimentos:any[] = [];

	seccionMarca:any = {
		productos:[]
	};
	seccionOtras:any = [];
	newOffsetSecciones: number = 0;
	hasSeccionMarca:boolean = false;
	

	@HostListener('window:resize', ['$event'])
	onResize(event) {
	  	this.fnChangeCarousel( event.target.innerWidth );
	}

  	constructor(
  		private newFuncionService:FuncionService,
  		private newRouter:Router,
  		private newTitle: Title,
  		@Inject(PLATFORM_ID) private platformId: Object
  	) {
  	}

  	fnCargarSecciones(){
  		this.newFuncionService.fnGetSecciones({max:1,offset:this.newOffsetSecciones}).subscribe( (response:any)=>{
      		if( response.success ){
      			if( response.lista.length > 0 ){
      				if(!this.hasSeccionMarca){
      					this.seccionMarca = response.lista[0];
      					if(this.seccionMarca){
      						this.hasSeccionMarca = true;
      					}
      				}
	      			response.lista.forEach( ( newItem ) =>{
	      				if(this.hasSeccionMarca){
	      					if( newItem.id !== this.seccionMarca.id ){
		      					this.seccionOtras.push( newItem )
		      				}
	      				}else{
	      					this.seccionOtras.push( newItem )
	      				}
	      			});
	      			this.newOffsetSecciones += 1;
	      			this.fnCargarSecciones();
      			}
      		}
      	});
  	}

  	ngOnInit(): void {
  		this.newTitle.setTitle("Pawerful. Tienda de mascotas de México");
  		if (isPlatformBrowser(this.platformId)) {
  			this.fnChangeCarousel( window.innerWidth );
      	}

      	this.newFuncionService.listaCategorias().subscribe( (response:any)=>{
      		if( response.length > 0 ){
      			this.listaCategorias = response;
      			this.listaCategorias[0].show = true;
      			this.listaSubcategorias = this.listaCategorias[0].subcategorias;
      		}
      	});

      	this.fnCargarSecciones();

      	let newMetatags:Metatags ={
			title:"Pawerful. Tienda de mascotas de México, compra en línea. Entrega exprés",
			description:"La tienda online de productos para mascotas, alimentos para perros y gatos premium con entrega exprés a todo México. Accesorios, ropa, juguetes y más.",
			image:'https://repo.ordenaris.com/pawerful/logotipos/portrait/logotipo.png',
			url:'https://www.pawerful.com',
			robots:'index, follow',
			keywords:"Alimento, mascotas, perros, gatos, juguetes, royal canin, Hill's, Nupec, Science diet, envío exprés, envío express, mascotas CDMX, camas, roedores, resptiles, aves, peces, transportadoras, antipulgas, desparacitante, satiety, support, recovery, lata, weight control, Royal weight control, hidrolized, carnaza, premios para perro, smartbones, petaco, arenero, arbol para gato, petco, +kota, mascotas, la tienda de frida, huellas, animalia, servicio a domicilio, mascotas CDMX, adopciones, feline, sudadera, capa, suéter, alimento premium, alimento seco, alimento húmedo, collares, correas, feline, kitten, a/d, hills, science diet, mobility, urinary, canine, smartsticks, kong, camas para perro, camas para gato, camas para mascota, cangurera perro, óptimo, purina, platos para perro, bebederos para perro, pechera para perro, collares gato, collar, correa",
		    language:"Spanish",
		    type:"website",
		    author:"Pawerful pet shop, S.A. de C.V."
		};
		this.newFuncionService.fnUpdateMetas( newMetatags );

  	}

  	fnMostrarSeccion( newSeccion ){
  		let newEncoder = new Base64();
  		var listaParams = [];
  		newSeccion.identificadores.forEach( (newItem:any)=>{
  			listaParams.push( `${encodeURI(newEncoder.encode( `${newItem.id}` ))}-${newItem.alias}` );
  		});
  		if(newSeccion.tipo === 1  ){
  			this.newRouter.navigate(["tienda"], { queryParams: {marcas: listaParams} });
  		}else{
  			this.newRouter.navigate(["tienda"], { queryParams: {categorias: listaParams} });
  		}
  	}

  	fnChangeCarousel( anchoWindow ){
  		this.anchoCarousel = anchoWindow;
  		this.listaCarousel = this.listaCarouselImages.desktop;
  		this.showCategorias = true;
  		this.numberOfShowMarcas = 4;
  		this.numberOfShowSubcategorias = 6;
  		if( window.innerWidth <= 768 ){
  			this.anchoCarouselTarjetas = ( parseInt($(".tarjetas").css("width")) );
  		}else{
  			this.anchoCarouselTarjetas = ( parseInt($(".tarjetas").css("width")) - 100 );
  		}
  		if( parseInt(anchoWindow) >= 768 && parseInt(anchoWindow) <= 1023 ){
  			this.altoCarousel = 235;
  			this.numberOfShowMarcas = 3;
  			this.numberOfShowSubcategorias = 4;
  		}else if( parseInt(anchoWindow) >= 1024 && parseInt(anchoWindow) <= 1365 ){
  			this.altoCarousel = 310;
  			this.numberOfShowMarcas = 4;
  		}else if( parseInt(anchoWindow) >= 1366 ){
  			this.altoCarousel = 440;
  			this.numberOfShowMarcas = 4;
  		}else{
  			this.altoCarousel = 435;
  			this.showCategorias = false;
  			this.numberOfShowMarcas = 1;

  			this.numberOfShowSubcategorias = 1;
  			this.listaCarousel = this.listaCarouselImages.movile;
  		}
  	}

  	fnImage( state ){
  		return this.listaCarousel[state - 1].img;
  	}

  	fnSeleccionCategoria( newCategoria ){
  		if( newCategoria.nivel === 1 ){
  			this.listaCategorias.forEach(function(newItem){
	  			newItem.seleccionado = false;
	  		});
	  		newCategoria.seleccionado = true;
	  		this.listaSubcategorias = newCategoria.subcategorias;
  		}else{
  			this.fnFiltrosTienda( newCategoria, 1 );
  		}
  	}

	fnFiltrosTienda( newData, newTipo ){
		let newEncoder = new Base64();
		if( newTipo === 1 ){
			this.newRouter.navigate(["tienda"], { queryParams: {categorias: [`${encodeURI(newEncoder.encode( `${newData.id}` ))}-${newData.alias}`]} });
		}else{
			this.newRouter.navigate(["tienda"], { queryParams: {marcas: [`${encodeURI(newEncoder.encode( `${newData.id}` ))}-${newData.alias}`]} });
		}
	}


}
